import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

const BookletViewer = ({ 
  content, 
  coverUrl,
  startClicked, 
  resourceIndex,
  htmResources,
  setHtmResources,
  isCollapsed
}) => {
  const bookletNumPagesRef = useRef(0);
  const bookletContainerRef = useRef(null);
  const bookletCurrentPageRef = useRef(0);
  
  useEffect(() => {    
    if(isCollapsed){
      bookletCurrentPageRef.current = 0;
      bookletNumPagesRef.current = 0;
      bookletContainerRef.current = null;
      let tempResources = [...htmResources];
      let selectedResource = htmResources[resourceIndex];
      selectedResource.bookletStartClicked = false;
      tempResources[resourceIndex] = selectedResource;
      setHtmResources(tempResources);
    }
  }, [isCollapsed]);

  const showBookletPage = (nPrevOrNext) => {
    let nNewPage;
    let numPages = bookletNumPagesRef.current;
    let currentPage = bookletCurrentPageRef.current;
    let container = bookletContainerRef.current;

    if (nPrevOrNext == 1) {
      let tempResources = [...htmResources];
      let selectedResource = htmResources[resourceIndex];
      selectedResource.bookletStartClicked = true;
      tempResources[resourceIndex] = selectedResource;
      setHtmResources(tempResources);

      const resourceDiv = document.getElementById(`resource${resourceIndex}`);
      container = resourceDiv.querySelector('table.booklet').closest('div');
      bookletContainerRef.current = container;

      numPages = container.querySelector('#booklet_numpages').value;
      bookletNumPagesRef.current = numPages;
    }

    switch (nPrevOrNext) {
    case 0:
      var a = container.querySelector('#header');
      if (a) {
        a.style.display = 'none';
      }
      nNewPage = 0;
      break;
    case 1:
      setBookletButtons();
      container.querySelector('#header').style.display = 'block';
      nNewPage = 1;
      currentPage = 0;
      break;
    case -1:
      nNewPage = currentPage == 1 ? numPages : currentPage - 1;
      break;
    case -2:
      nNewPage = currentPage == numPages ? 1 : currentPage + 1;
      break;
    default:
      return;
    }
    bookletCurrentPageRef.current = nNewPage;
    
    const currentPageElement = container.querySelector(`#page${currentPage}`);
    const newPageElement = container.querySelector(`#page${nNewPage}`);

    currentPageElement.classList.add('rs_skip');
    currentPageElement.style.display = 'none';
    newPageElement.classList.remove('rs_skip');
    newPageElement.style.display = 'block';

    container.dataset.currPage = nNewPage;

    const btnPrev = container.querySelector('#btnprev');
    const btnNext = container.querySelector('#btnnext');
    const btnHome = container.querySelector('#btnhome');

    if (nNewPage == numPages) {
      btnPrev.style.display = 'inline';
      btnNext.style.display = 'none';
      btnHome.style.display = 'none';
    } else {
      btnPrev.style.display = 'inline';
      btnNext.style.display = 'inline';
      btnHome.style.display = 'none';
    }
  };

  const setBookletButtons = () => {
    const resourceDiv = document.getElementById(`resource${resourceIndex}`);
    const container = resourceDiv.querySelector('table.booklet').closest('div');
    if (container) {
      const btnNext = container.querySelector('#btnnext');
      const btnPrev = container.querySelector('#btnprev');
      const btnHome = container.querySelector('#btnhome');

      if (btnNext) {

        const button = document.createElement('input');
        button.type = 'button';
        button.value = '  →  ';
        button.style.display = 'inline';
        button.onclick = () => showBookletPage(-2);

        btnNext.innerHTML = '';
        btnNext.appendChild(button);
      }
      if (btnPrev) {
        const button = document.createElement('input');
        button.type = 'button';
        button.value = '  ←  ';
        button.style.display = 'inline';
        button.onclick = () => showBookletPage(-1);

        btnPrev.innerHTML = '';
        btnPrev.appendChild(button);
      }
      if (btnHome) {
        const button = document.createElement('input');
        button.type = 'button';
        button.value = 'Cover';
        button.style.display = 'inline';
        button.onclick = () => showBookletPage(0);

        btnHome.innerHTML = '';
        btnHome.appendChild(button);
      }
    }
  };
  
  return (
    <div id={`resource${resourceIndex}`} className={isCollapsed && 'd-none'}>
      <div className={`box-background border-2 border-bottom mb-4 ${!startClicked ? '' : 'd-none'}`}>
        <div className='text-center'> <img src={coverUrl}></img> </div>
        <div className='text-center'>  <button onClick={() => { showBookletPage(1); }}>Start</button></div>
      </div>
      <div className={`box-background border-top mb-5 ${startClicked ? '' : 'd-none'}`} dangerouslySetInnerHTML={{ __html: content }}></div>
    </div>
  );
};

BookletViewer.propTypes = {
  content: PropTypes.string,
  coverUrl: PropTypes.string,
  startClicked: PropTypes.bool,
  onStart: PropTypes.func,
  resourceIndex: PropTypes.number,
  htmResources:PropTypes.array,
  setHtmResources:PropTypes.func,
  isCollapsed:PropTypes.bool
};
  
export default BookletViewer;